module.exports = new __parcel__URL__("linkedin.e88b6608.svg").toString();